import React, { useEffect, useState } from "react";
import Div from "@jumbo/shared/Div";
import * as yup from "yup";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import Select from "@mui/material/Select";
import LoadingButton from "@mui/lab/LoadingButton";
import Stack from "@mui/material/Stack";
import JumboAvatarField from "@jumbo/components/JumboFormik/JumboAvatarField";
import { Form, Formik } from "formik";
import DDImageField from "../../../../component/DDImageField";
import { useTranslation } from "react-i18next";
import {
  COUNTRIES,
  countryFormattingRules,
  PHONE_COUNTRIES,
  timings,
} from "../../../../utils/constants/appActions";
import Grid from "@mui/material/Grid";
import FormControlLabel from "@mui/material/FormControlLabel";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import BubbleChartIcon from "@mui/icons-material/BubbleChart";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useAppMutation } from "../../../../services";
import parentServices from "../../../../services/parent-services";
import commonServices from "../../../../services/common-services";
import moment from "moment";
import { useSelector } from "react-redux";
import Checkbox from "@mui/material/Checkbox";

const steps = [
  "Select campaign settings",
  "Create an ad group",
  "Create an ad",
];
const validationSchema = yup.object({
  email: yup
    .string("Enter your email")
    .email("Enter a valid email")
    .required("Email is required"),
  password: yup.string("Enter your password").required("Password is required"),
});

const Step1 = ({
  hideDialog = { hideDialog },
  stepsData,
  handleNext,
  setStepsData,
}) => {
  const { authUser } = useSelector((state) => state.auth);
  const [isLoading, setIsLoading] = React.useState(false);
  const [values, setValues] = React.useState({
    firstName: "",
    lastName: "",
    dateOfBirth: null,
    startDate: null,
    startTime: null,
    gender: "",
    profileImage: "",
    homeworkLesson: "",
    substituteTeacher: "",
  });
  const [errMsg, setErrMsg] = React.useState("");
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const [pastDate, setPastDate] = useState(false);
  const [maxDate, setMaxDate] = useState();
  const [minDate, setMinDate] = useState();
  const [type] = useState("evaluation");
  const [sTimings, setSTimings] = useState([]);


  console.log("stepsData----123:", stepsData);

  const {
    mutate: loadAvailableDates,
    isSuccess: isLDSuccess,
    isLoading: isLDLoading,
    isError: isLDError,
    data: ldResult,
  } = useAppMutation(parentServices.loadAvailableDates);

  const {
    mutate: loadAvailableTimes,
    isSuccess: isLTSuccess,
    isLoading: isLTLoading,
    isError: isLTError,
    data: ltResult,
  } = useAppMutation(parentServices.loadAvailableTimes);

  useEffect(() => {
    console.log("LD Result", isLTSuccess, ltResult);

    if (isLTError) {
      setSTimings([]);
      return;
    }

    if (!ltResult) {
      setSTimings([]);
      return;
    }

    const start = values?.startDate;
    if (!(start instanceof Date) || isNaN(start.getTime())) {
      setSTimings([]);
      return;
    }

    console.log("ltResult---->>>", ltResult);
    const startDate = moment(start).format("YYYY-MM-DD");
    console.log("startStr---->>>", startDate);
    const now = new Date();
    const ls = [];

    for (const t of ltResult.timings) {
      let date = new Date(`${startDate}T${t}`);
      const userTimezoneOffset = date.getTimezoneOffset() * 60000;
      date = new Date(date.getTime() - userTimezoneOffset);

      if (date > new Date()) {
        const v = timings.find(
          (item) => item.value === moment(date).format("HH:mm"),
        );

        if (v) {
          ls.push(v);
        }
      }
    }

    console.log("ls---->>>", ls);

    setSTimings(ls);
  }, [isLTSuccess, isLTError]);

  React.useEffect(() => {
    if (!minDate) {
      const currentMin = new Date();
      const currentMax = new Date();
      currentMin.setDate(currentMin.getDate()+2);
      setMinDate(currentMin);
      currentMax.setDate(currentMax.getDate() + 30);
      setMaxDate(currentMax);
      loadAvailableDates({ type, startDate: currentMin, endDate: currentMax });
    }
  }, [minDate]);

  useEffect(() => {
    if (stepsData) {
      const ae = stepsData?.appointmentEvaluation || {};

      const v = {
        ...values,
        ...stepsData,

        homeworkLesson: ae?.homeworkLesson ?? "",
        substituteTeacher: ae?.substituteTeacher ?? "",
      };

      setValues(v);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stepsData]);

  const handleChange = (prop) => (event) => {
    let value = event.target.value;
    setValues({ ...values, [prop]: value });
  };

  const getMaxDate = () => {
    return new Date().toISOString().split("T")[0];
  };

  const submitStep = async () => {
    setErrMsg("");

    try {
      setIsLoading(true);

      // clone current form state
      let v = { ...values };

      // Basic required fields validation
      const { firstName, lastName, gender, dateOfBirth } = v;
      const isEdit = Boolean(stepsData?.studentId);

      if (
          !firstName ||
          !lastName ||
          !gender ||
          !dateOfBirth ||
          (!isEdit && (!v.startDate || !v.startTime))
      ) {
        setErrMsg("Please fill all required fields");
        setIsLoading(false);
        setTimeout(() => setErrMsg(""), 3000);
        return;
      }

      // Handle image conversion if newImage exists
      if (v.newImage) {
        const b = await fetch(v.newImage).then((r) => r.blob());
        v.imageBase64 = await commonServices.blobToBase64(b);
      }

      // If creating booking (NOT edit), compute start/end datetime
      if (!isEdit) {
        const startDateStr = moment(v.startDate).format("YYYY-MM-DD");
        const startTime = v.startTime;

        const selectedStartDateTime = new Date(`${startDateStr}T${startTime}`);
        const selectedEndDateTime = new Date(`${startDateStr}T${startTime}`);
        selectedEndDateTime.setMinutes(selectedEndDateTime.getMinutes() + 30);

        v.startDate = selectedStartDateTime;
        v.endDate = selectedEndDateTime;
      }

      // If editing, send appointmentEvaluation with these 2 fields
      if (isEdit) {
        v.appointmentEvaluation = {
          ...(stepsData?.appointmentEvaluation || {}),
          homeworkLesson: v.homeworkLesson,       // "yes" | "no"
          substituteTeacher: v.substituteTeacher, // "yes" | "no"
        };
      }

      // (Optional) keep payload clean: remove these from root if you only want them in appointmentEvaluation
      // delete v.homeworkLesson;
      // delete v.substituteTeacher;

      console.log("=== Saving Child Payload ===", {
        ...v,
        parentId: authUser._id,
      });

      // Save child
      const resp = await parentServices.saveChild({
        ...v,
        parentId: authUser._id,
      });

      console.log("=== Save Child Response ===", resp);

      // Push to dataLayer (keep your existing tracking)
      const {
        firstName: parentFirstName,
        lastName: parentLastName,
        email: parentEmail,
        dateOfBirth: parentDateOfBirth,
      } = authUser;

      const { phone, country } = v;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "ParentAddChild",
        gender,
        dateOfBirth,
        parentFirstName,
        country: country?.label,
        phone: phone?.fullNumber,
        parentLastName,
        parentEmail,
        firstName,
        lastName,
        parentDateOfBirth,
      });

      handleNext(5);
    } catch (error) {
      console.error("submitStep error:", error);
      setErrMsg(error?.message || "Something went wrong");
      setIsLoading(false);
    } finally {
      // ensure loader always stops
      setIsLoading(false);
    }
  };

  const submitStepqqq = async () => {
    setErrMsg("");
    console.log(values);

    try {
      setIsLoading(true);

      let v = {
        ...values,
      };

      // Basic required fields validation
      const { firstName, lastName, gender, dateOfBirth } = v;

      const isEdit = Boolean(stepsData?.studentId);

      if (
        !firstName ||
        !lastName ||
        !gender ||
        !dateOfBirth ||
        (!isEdit && (!v.startDate || !v.startTime))
      ) {
        setErrMsg("Please fill all required fields");
        setIsLoading(false);
        return setTimeout(() => setErrMsg(""), 3000);
      }

      // Handle image conversion if newImage exists
      if (v.newImage) {
        let b = await fetch(v.newImage).then((r) => r.blob());
        v.imageBase64 = await commonServices.blobToBase64(b);
      }

      console.log("v----", v);
      const startDate = moment(v.startDate).format("YYYY-MM-DD");
      const startTime = v.startTime;
      const selectedStartDateTime = new Date(`${startDate}T${startTime}`);
      const selectedEndDateTime = new Date(`${startDate}T${startTime}`);
      selectedEndDateTime.setMinutes(selectedEndDateTime.getMinutes() + 30);

      v.startDate = selectedStartDateTime;
      v.endDate = selectedEndDateTime;

      // Save child
      await parentServices.saveChild({
        ...v,
        parentId: authUser._id,
      });

      console.log("Submitted Data-------", v);

      // Extract parent info
      const {
        firstName: parentFirstName,
        lastName: parentLastName,
        email: parentEmail,
        dateOfBirth: parentDateOfBirth,
      } = authUser;
      const { phone, country } = v;

      // Push to dataLayer
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "ParentAddChild",
        gender,
        dateOfBirth,
        parentFirstName,
        country: country?.label,
        phone: phone?.fullNumber,
        parentLastName,
        parentEmail,
        firstName,
        lastName,
        parentDateOfBirth,
      });

      handleNext(5);
    } catch (error) {
      console.log(error);
      setErrMsg(error.message);
      setIsLoading(false);
    }
  };

  return (
    <>
      <Div
        sx={{
          p: 1,
          color: "#000",
          maxWidth: 600,
          mx: "auto",
        }}
      >
        <Formik
          validateOnChange={true}
          initialValues={values}
          enableReinitialize={true}
          validationSchema={validationSchema}
          onSubmit={() => {}}
        >
          {({ isSubmitting, setFieldValue }) => (
            <Form noValidate autoComplete="off">
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    size="small"
                    margin="none"
                    sx={{
                      mb: { xs: 1, md: 2 },
                      "& .MuiInputBase-input": {
                        fontFamily: "'Lexend', sans-serif",
                      },
                      "& .MuiInputLabel-root": {
                        fontFamily: "'Lexend', sans-serif",
                      },
                    }}
                    required
                    label={t("parent-children.title.firstName1")}
                    value={values.firstName}
                    onChange={handleChange("firstName")}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    size="small"
                    margin="none"
                    sx={{
                      mb: { xs: 1, md: 2 },
                      "& .MuiInputBase-input": {
                        fontFamily: "'Lexend', sans-serif",
                      },
                      "& .MuiInputLabel-root": {
                        fontFamily: "'Lexend', sans-serif",
                      },
                    }}
                    required
                    label={t("parent-children.title.surname")}
                    value={values.lastName}
                    onChange={handleChange("lastName")}
                  />
                </Grid>
              </Grid>

              <Grid
                container
                spacing={2}
                alignItems="center"
                sx={{ mt: 1, mb: 2 }}
              >
                <Grid item xs={12} md={6}>
                  <TextField
                    id={`date`}
                    required
                    label={t("parent-children.title.dateBirth")}
                    type="date"
                    fullWidth
                    size="small"
                    inputProps={{
                      max: getMaxDate(),
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={values.dateOfBirth}
                    onChange={handleChange("dateOfBirth")}
                    sx={{
                      "& .MuiInputBase-input": {
                        fontFamily: "'Lexend', sans-serif",
                      },
                      "& .MuiInputLabel-root": {
                        fontFamily: "'Lexend', sans-serif",
                      },
                    }}
                  />
                </Grid>

                {/* Gender Selection */}
                <Grid item xs={12} md={6}>
                  <FormControl
                    component="fieldset"
                    sx={{ mt: { xs: 1, md: 0 } }}
                  >
                    <RadioGroup
                      row
                      value={values.gender}
                      onChange={handleChange("gender")}
                      aria-label="gender"
                      name={`child-gender-group`}
                      sx={{
                        "& .MuiFormControlLabel-label": {
                          fontFamily: "'Lexend', sans-serif",
                        },
                      }}
                    >
                      <FormControlLabel
                        value="male"
                        control={<Radio size="small" />}
                        label={t("parent-children.title.boy")}
                      />
                      <FormControlLabel
                        value="female"
                        control={<Radio size="small" />}
                        label={t("parent-children.title.girl")}
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
              </Grid>

              <Box sx={{ textAlign: "center", mb: 3, mt: 4 }}>
                {!values.newImage && values.images?.length > 0 ? (
                  <DDImageField
                    name={"profile_pic"}
                    alt={"user profile pic"}
                    onFileSelection={async (file) => {
                      let b = await fetch(file).then((r) => r.blob());
                      if (b.size > 1000000) {
                        setErrMsg(t("errMsg.sizeErr"));
                        setTimeout(() => {
                          setErrMsg("");
                        }, 3000);
                      } else {
                        setValues({ ...values, newImage: file });
                      }
                    }}
                    sx={{ width: 60, height: 60, margin: "0 auto 24px" }}
                    path={values.images[0]}
                    alt={values.firstName + " " + values.lastName}
                  />
                ) : (
                  <JumboAvatarField
                    name={"profile_pic"}
                    alt={"user profile pic"}
                    src={values.newImage}
                    onFileSelection={async (file) => {
                      let b = await fetch(file).then((r) => r.blob());
                      if (b.size > 1000000) {
                        setErrMsg(t("errMsg.sizeErr"));
                        setTimeout(() => {
                          setErrMsg("");
                        }, 3000);
                      } else {
                        setValues({ ...values, newImage: file });
                      }
                    }}
                    sx={{ width: 60, height: 60, margin: "0 auto 24px" }}
                  />
                )}
              </Box>

              <Box sx={{ textAlign: "center", mb: 3, mt: 2 }}>
                <Typography
                  sx={{
                    mt: 1,
                    color: "#003366", // dark blue
                    fontWeight: "bold",
                    fontSize: "1.15rem", // ~20px
                    fontFamily: "'Red Hat Display', sans-serif",
                  }}
                >
                  {stepsData?.studentId
                      ? t("parent-children.title.childUpdateMsg1")
                      : t("parent-children.title.childNewMsg1")}
                </Typography>

                <Typography
                    sx={{
                      mt: 1,
                      mb: 2,
                      color: "#003368",
                      fontFamily: "'Lexend', sans-serif",
                    }}
                >
                  {stepsData?.studentId ? (
                      t("parent-children.title.childUpdateMsg2")
                  ) : (
                      <>
                        {t("parent-children.title.childNewMsg2")}
                        <br />
                        {t("parent-children.title.childNewMsg3")}
                      </>
                  )}
                </Typography>

                {/*<Typography
                  sx={{
                    mt: 1,
                    mb: 2,
                    color: "#003368", // light blue
                    fontFamily: "'Lexend', sans-serif",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: stepsData?.studentId
                      ? t("parent-children.title.childUpdateMsg2")
                        : `${t("parent-children.title.childNewMsg2")} <br /> ${t(
                            "parent-children.title.childNewMsg33"
                        )}`,
                  }}
                />*/}
              </Box>

              {stepsData?.studentId && stepsData?.appointmentEvaluation && (

              <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 0.5,              // spacing between lines
                    alignItems: "flex-start",
                    mx: "auto",
                    width: "100%",
                    maxWidth: 520,
                    border: "1px solid #eef1f5",
                    borderRadius: 3,
                    overflow: "hidden",
                    backgroundColor: "#fff",
                    boxShadow: "0 1px 6px rgba(16, 24, 40, 0.06)",
                  }}
              >
                {[
                  { key: "homeworkLesson", label: t("parent-children.title.homeWorkLesson") },
                  { key: "substituteTeacher", label: t("parent-children.title.substituteTeacher") },
                ].map((row) => (
                    <FormControlLabel
                        key={row.key}
                        sx={{
                          width: "100%",      // each takes full line
                          m: 0,               // remove default margin
                          display: "flex",
                        }}
                        control={
                          <Checkbox
                              checked={values[row.key] === "yes"}
                              onChange={(e) =>
                                  setValues((prev) => ({
                                    ...prev,
                                    [row.key]: e.target.checked ? "yes" : "no",
                                  }))
                              }
                              sx={{
                                color: "#1D6ADE",
                                "&.Mui-checked": { color: "#1D6ADE" },
                              }}
                          />
                        }
                        label={
                          <Typography
                              sx={{
                                fontFamily: "'Lexend', sans-serif",
                                fontSize: 14,
                                fontWeight: 500,
                                color: "#2b3445",
                              }}
                          >
                            {row.label}
                          </Typography>
                        }
                    />
                ))}
              </Box>
              )}


              {!stepsData?.studentId && (
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  sx={{ mt: 1, mb: 2 }}
                >
                  {/* Date Picker */}
                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Stack spacing={3}>
                          <DesktopDatePicker
                            open={open}
                            onOpen={() => setOpen(true)}
                            onClose={() => setOpen(false)}
                            shouldDisableDate={(day) => {
                              if (pastDate) {
                                return false;
                              }
                              const formatted =
                                moment(day).format("YYYY-MM-DD");
                              const today = moment().format("YYYY-MM-DD");

                              // ❌ Disable today
                              if (formatted === today) {
                                return true;
                              }
                              if (
                                ldResult?.availableDates &&
                                ldResult.availableDates.includes(
                                  moment(day).format("YYYY-MM-DD"),
                                )
                              ) {
                                return false;
                              }
                              return true;
                            }}
                            minDate={pastDate ? undefined : minDate}
                            maxDate={pastDate ? undefined : maxDate}
                            label={t("common.date")}
                            format="dd/MM/yyyy"
                            value={values?.startDate ?? null}
                            onChange={(newDate) => {
                              // newDate is a Date or null
                              setValues((prev) => ({
                                ...prev,
                                startDate: newDate ?? null,
                              }));

                              if (newDate) {
                                // If you need to load times immediately after picking a date:

                                const date =
                                  moment(newDate).format("YYYY-MM-DD");

                                loadAvailableTimes({ type, date });
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                InputLabelProps={{ shrink: true }}
                                sx={{
                                  "& .MuiInputBase-input": {
                                    fontFamily: "'Lexend', sans-serif",
                                  },
                                  "& .MuiInputLabel-root": {
                                    fontFamily: "'Lexend', sans-serif",
                                  },
                                }}
                              />
                            )}
                          />
                        </Stack>
                      </LocalizationProvider>
                    </FormControl>
                  </Grid>

                  {/* Time Select */}
                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <>
                        <InputLabel id="demo-simple-select-label">
                          {t("parent.title.time")}
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label={t("common.time")}
                          value={values?.startTime ?? null}
                          onChange={(e) =>
                            setValues((prev) => ({
                              ...prev,
                              startTime: e.target.value,
                            }))
                          }
                          sx={{
                            "& .MuiSelect-select": {
                              fontFamily: "'Lexend', sans-serif",
                            },
                          }}
                        >
                          {sTimings.map((item, index) => (
                            <MenuItem key={index} value={item.value}>
                              {item.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </>
                    </FormControl>
                  </Grid>
                </Grid>
              )}

              <Box
                sx={{
                  width: "100%", // full width of the form container
                  minHeight: 50,
                  mb: 2,
                  mt: 1,
                }}
              >
                {errMsg && (
                  <Alert
                    severity="error"
                    sx={{
                      height: "100%",
                      fontSize: 13,
                      fontFamily: "'Lexend', sans-serif",
                    }}
                  >
                    {errMsg}
                  </Alert>
                )}
              </Box>


              <Button
                variant="outlined"
                fullWidth
                startIcon={<BubbleChartIcon />}
                sx={{
                  mb: 2,
                  borderRadius: 3,
                  textTransform: "none",
                  backgroundColor: "#1D6ADE",
                  fontFamily: "'Lexend', sans-serif",
                  color: "#fff",
                  "&:hover": {
                    backgroundColor: "#265ca6", // darker red on hover
                  },
                }}
                disabled={isLoading}
                onClick={submitStep}
              >
                {isLoading
                  ? "........."
                  : stepsData?.studentId
                    ? t("common.updateChild")
                    : t("common.childBookingSave")}
              </Button>
            </Form>
          )}
        </Formik>
      </Div>
    </>
  );
};

export default Step1;
